module.exports = __webpack_public_path__ + "static/media/02A.99519f3f.png";